import { ProfileEditRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const editRoute = {
  path: 'edit',
  element: <ProfileEditRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Edit</span>,
  }),
};